import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import type { SupportedLang } from "@/i18n";

export const getLangFromCookie = createServerFn({ method: "GET" }).handler(
  async () => {
    const lang = getCookie("munchi-lang");
    return (lang === "fi" || lang === "en" ? lang : "en") as SupportedLang;
  },
);
